export const normalizeContactData = (contactData) => {
  if (!contactData) return null;

  // Search results carry the company as `company: {id, name, ...}`; keep it as company_detail
  // because `company` becomes the company's name below
  const companyObject = contactData.company_detail ||
                        (contactData.company && typeof contactData.company === 'object' ? contactData.company : null) ||
                        contactData.current_company_detail ||
                        contactData.primary_company ||
                        null;

  const full_name = contactData.full_name ||
                   contactData.name || 
                   `${contactData.first_name || ''} ${contactData.last_name || ''}`.trim() ||
                   contactData.headline ||
                   'Unknown Contact';

  return {
    ...contactData,

    full_name,
    company_detail: companyObject,
    
    work_experience: Array.isArray(contactData.work_experience_structured) 
      ? contactData.work_experience_structured 
      : Array.isArray(contactData.work_experience) 
        ? contactData.work_experience 
        : [],
    
    education: Array.isArray(contactData.education) 
      ? contactData.education 
      : [],
    
    skills: Array.isArray(contactData.skills) 
      ? contactData.skills 
      : [],
    
    profile_image_url: contactData.profile_image_url || contactData.photo_url || null,
    phone: contactData.phone || contactData.phone_number || null,
    linkedin_url: contactData.linkedin_url || contactData.linkedin || contactData.url || null,
    website: contactData.website || contactData.personal_website || null,
    email: contactData.email_address || contactData.email || null,
    
    title: contactData.headline || contactData.title || contactData.job_title || contactData.position_detail?.name || contactData.position?.name || contactData.position_name || null,
    company: (typeof contactData.company === 'object' ? contactData.company?.name : contactData.company) || 
             contactData.company_detail?.name || 
             contactData.current_company_detail?.name || 
             contactData.company_name ||
             contactData.primary_company?.name || null,
    company_name: (typeof contactData.company === 'object' ? contactData.company?.name : contactData.company) || 
                  contactData.company_detail?.name || 
                  contactData.current_company_detail?.name || 
                  contactData.company_name ||
                  contactData.primary_company?.name || null,
    sector: contactData.sector || contactData.industry || contactData.company?.industry || contactData.company_detail?.industry || contactData.current_company_detail?.industry || null,
    industry: contactData.industry || contactData.sector || contactData.company?.industry || contactData.company_detail?.industry || contactData.current_company_detail?.industry || null,
    bio: contactData.bio || contactData.summary || null,
    
    logo_uuid: contactData.logo_uuid || companyObject?.logo_uuid || null,
    company_logo_url: contactData.company_logo_url || 
                      contactData.company_detail?.logo_url || 
                      contactData.current_company_detail?.logo_url ||
                      contactData.primary_company?.logo_url || null,
    
    known_by: Array.isArray(contactData.known_by) ? contactData.known_by :
              (typeof contactData.advisor_name === 'string' ? [contactData.advisor_name] : []),

    advisor: typeof contactData.advisor_name === 'string' ? contactData.advisor_name :
             typeof contactData.contact_source === 'string' ? contactData.contact_source :
             typeof contactData.provider === 'string' ? contactData.provider :
             typeof contactData.sources?.[0] === 'string' ? contactData.sources[0] :
             typeof contactData.sources?.[0] === 'object' ? contactData.sources[0]?.name :
             null,
    
    city_name: contactData.city_name || (typeof contactData.city === 'object' ? contactData.city?.name : contactData.city) || null,
    country_name: contactData.country_name || (typeof contactData.country === 'object' ? contactData.country?.name : contactData.country) || null,
    
    ...((!Array.isArray(contactData.work_experience_structured) || contactData.work_experience_structured.length === 0) && 
        (!Array.isArray(contactData.work_experience) || contactData.work_experience.length === 0) &&
        (contactData.position_detail?.name || contactData.position?.name || companyObject?.name || contactData.headline) && {
      work_experience: [{
        id: 'current',
        title: contactData.position_detail?.name || contactData.position?.name || contactData.headline || contactData.title || 'Position Not Specified',
        company: companyObject?.name || (typeof contactData.company === 'string' ? contactData.company : null) || 'Company Not Specified',
        company_logo_url: null,
        location: contactData.city_name && contactData.country_name 
          ? `${contactData.city_name}, ${contactData.country_name}` 
          : contactData.city_name || contactData.country_name || null,
        start_date: null,
        end_date: null,
        duration: 'Current Position',
        description: contactData.bio || contactData.summary || null,
        is_current: true,
        employment_type: 'Full-time'
      }]
    })
  };
};
